import { FC } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import cx from 'classnames'
import { createUseStyles } from 'react-jss'

import { sansSerifFontFamily } from 'utils/styles'

const useStyles = createUseStyles({
  container: {
    height: 64,
    width: '100%',
    marginTop: 48,
    background:
      'radial-gradient(103.73% 266.85% at 0% 16.08%, #CF8355 0%, #CEAF85 38.44%, #9B876D 100%)',
    borderRadius: 2,
    color: '#ffffff',
    border: 'none',
    cursor: 'pointer',
    fontFamily: sansSerifFontFamily,
    fontWeight: 900,
    fontSize: 14,
    lineHeight: '140%',
    letterSpacing: 1.6,
  },
  disabledStyle: {
    background: 'rgba(54, 52, 50, 0.24)',
    color: ' rgba(255, 255, 255, 0.24)',
    cursor: 'auto',
  },
})

interface Props {
  text?: string
  onClick: () => void
  disabled?: boolean
}

export const TextButton: FC<Props> = flowMax(
  addDisplayName('Button'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ text, onClick, disabled, classes }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cx(classes.container, disabled && classes.disabledStyle)}
    >
      {text}
    </button>
  )
)
